export const MainWrapper = 'flex flex-col w-full'

export const Headline = 'mb-4 text-black font-Roboto'

export const ListWrapper = 'flex flex-col'

export const TotalOrders =
  'font-Roboto text-16 leading-18 uppercase text-black pb-4 border-b border-machine2-75 mb-6'

export const LoadMoreButton = 'w-full sm:w-1/3'
